import { createRoot } from "react-dom/client";
import React, { Suspense } from "react";
import "./index.css";
import App from "./App";

createRoot(document.getElementById("root")).render(
  <Suspense fallback={null}>
    <App />
  </Suspense>
);
